import sanitize from 'sanitize-html'
import styled from 'styled-components'
import {
  calculateForeground,
  DynamicContentType,
  TipsBoxData,
  WebsiteConfigBM,
} from '@bm-js/atlascloud-shared'

const StyledTipsBoxContent = styled.div<{
  $alignment: string
  $inverseColor: string
  $baseColor: string
}>`
  padding: 1rem;
  display: flex;
  width: 100%;
  max-width: 60ch;
  ${({ $alignment }) =>
    $alignment === 'center' ? 'text-align: center; margin: auto;' : ''}
  color: ${({ $inverseColor }) => $inverseColor};
  .tips-box-content-inner {
    width: 100%;
    padding: 0.5rem 1rem;
    background: ${({ $baseColor }) => $baseColor};
    box-shadow:
      0px 1px 3px rgba(16, 24, 40, 0.2),
      0px 1px 2px rgba(16, 24, 40, 0.2);
  }
`

type Props = {
  content: DynamicContentType<TipsBoxData>
  websiteConfig: WebsiteConfigBM
}

const TipsBoxContent = ({ content, websiteConfig }: Props) => {
  return (
    <StyledTipsBoxContent
      $alignment={content.data.alignment}
      $baseColor={websiteConfig.colors.base}
      $inverseColor={calculateForeground(websiteConfig.colors.base)}
    >
      <div
        className='tips-box-content-inner'
        dangerouslySetInnerHTML={{ __html: sanitize(content.data.content) }}
        style={{
          marginBottom: content.data.marginBottom,
        }}
      />
    </StyledTipsBoxContent>
  )
}

export default TipsBoxContent
